export default defineNuxtRouteMiddleware(async (to) => {
  if (to.path.startsWith('/login')) {
    return
  }

  const { isAuthenticated } = useSanctumAuth()
  const user = useSanctumUser<any>()

  if (!isAuthenticated.value) {
    return navigateTo({
      path: '/login',
      query: { redirect: to.fullPath }
    })
  }

  const isSuperAdmin = Boolean(
    user.value?.superAdmin || 
    user.value?.super_admin || 
    user.value?.roles?.includes('SUPER_ADMIN')
  )

  const discordId = user.value?.discordId || user.value?.discord_id
  if (!discordId && !isSuperAdmin) {
    return navigateTo({
      path: '/login',
      query: { error: 'no_discord_linked' }
    })
  }

  // Check Discord Admin role using cached state for navigation speed
  const isDiscordAdmin = useState<boolean | null>('auth:isDiscordAdmin', () => null)

  if (isSuperAdmin) {
    isDiscordAdmin.value = true
  } else if (isDiscordAdmin.value === null) {
    try {
      const res = await $fetch<{ isAdmin: boolean; isStaff: boolean }>('/api/auth/discord-admin-check', {
        params: { discordId }
      })
      isDiscordAdmin.value = Boolean(res.isAdmin || res.isStaff)
    } catch (e) {
      console.error('Failed to verify Discord admin role:', e)
      isDiscordAdmin.value = false
    }
  }

  if (!isDiscordAdmin.value) {
    return navigateTo({
      path: '/login',
      query: { error: 'not_discord_admin' }
    })
  }
})
